import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { getCurrentUser } from "../util/amplifyAuth";

export default function AuthLayout() {
    const [checked, setChecked] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Skip auth redirect on /signup — the signup flow manages its own post-auth state
        if (location.pathname === '/signup') {
            setChecked(true);
            return;
        }
        getCurrentUser()
            .then(() => navigate("/home", { replace: true }))
            .catch(() => setChecked(true));
    }, [navigate, location.pathname]);

    if (!checked) return null;

    return <Outlet />;
}
